'use strict';

angular.module('internal.licenses')
    .controller('InternalLicenseScheduledTaskPreview', ['$rootScope', '$scope', '$stateParams', '$state', 'LicenseCategories', 'LicenseScheduledTasks', 'LicenseScheduledTaskLogs', function ($rootScope, $scope, $stateParams, $state, LicenseCategories, LicenseScheduledTasks, LicenseScheduledTaskLogs) {
        $scope.resetLicense();
        $scope.scheduledTaskID = $stateParams.scheduledTaskID;
        $scope.isDisabledCriteriaOpen = true;
        $scope.isFoundCertificationsOpen = true;
        $scope.isTroubleshootingQueryOpen = true;
        $scope.foundCertificationsLoading = true;
        $scope.sql_string = "";
        $scope.isSuperUser = $rootScope.userAccount.super;
        $scope.running = false;

        $scope.fromOptions = [
            { name: 'From', id: 'from' },
            { name: 'Exactly on', id: 'exact' }
        ];

        $scope.dayPartOptions = [
            { name: 'day(s)', id: 'day' },
            { name: 'month(s)', id: 'month' },
            { name: 'year(s)', id: 'year' }
        ];

        $scope.comparisonOptions = [
            { name: 'before', id: 'before' },
            { name: 'after', id: 'after' }
        ];

        $scope.serviceOptions = [
            { name: 'Does not have any affiliation', id: 'none' },
            { name: 'Must have at least one affiliation', id: 'any' }
        ];

        LicenseCategories.getByID($scope.licenseCategoryID).then(function (licenseCategory) {
            $scope.isUserEntity = licenseCategory.user_entity;
            $scope.isServiceEntity = licenseCategory.service_entity;
            $scope.isVehicleEntity = licenseCategory.vehicle_entity;
        });

        LicenseCategories.getByID($scope.licenseCategoryID).then(function (licenseCategory) {
            if (licenseCategory.vehicle_entity == true) {
                $scope.variablelabel = $scope.enterprise.vehicleLabels["VEHICLE"] + ' Serial Number';
            }
            else if (licenseCategory.service_entity == true) {
                $scope.variablelabel = $scope.enterprise.serviceLabels["SERVICE"] + ' Name';
            }
            else if (licenseCategory.user_entity == true) {
                $scope.variablelabel = $scope.enterprise.userLabels["USER"] + ' Full Name';
            }
            else {
                $scope.variablelabel = 'Entity';
            }

            $scope.foundColumns = [
                {
                    label: $scope.variablelabel,
                    field: 'entity',
                    type: 'text',
                    cfvariableurl: 'certification_url',
                    cfparam: 'entity_id'
                },
                {
                    label: 'Certification Number',
                    field: 'certification_number',
                    type: 'text'
                },
                {
                    label: 'Certification Status',
                    field: 'certification_status',
                    type: 'text'
                },
                {
                    label: 'Certification Levels',
                    field: 'certification_levels',
                    type: 'text'
                },
                {
                    label: 'Certification Issue Date',
                    field: 'certification_issue_date',
                    type: 'date'
                },
                {
                    label: 'Certification Expiration Date',
                    field: 'certification_expiration_date',
                    type: 'date'
                }
            ];
        });

        $scope.getCertifications = function () {
            LicenseScheduledTasks.getCertificationIDs($scope.scheduledTaskID).then(function (scheduled_task_certifications) {
                if (scheduled_task_certifications != null) {
                    if (scheduled_task_certifications.hasOwnProperty('certificationssqlstring')) {
                        $scope.sql_string = scheduled_task_certifications.certificationssqlstring;
                    }

                    if (scheduled_task_certifications.hasOwnProperty('certificationlist')) {
                        if (scheduled_task_certifications.certificationlist.length > 0) {

                            var i;
                            var certsArray = [];
                            for (i = 0; i <= scheduled_task_certifications.certificationlist.length - 1; i++) {
                                var certID = scheduled_task_certifications.certificationlist[i].certificationid;
                                certsArray.push(certID);
                            }

                            LicenseScheduledTasks.getCertifications({ certsArray: certsArray }).then(function (certifications) {
                                $scope.certifications = certifications;
                            });
                        } else {
                            $scope.certifications = [];
                        }
                    }
                } else {
                    $scope.certifications = [];
                }
            });
            $scope.foundCertificationsLoading = false;
        }
        $scope.getCertifications();

        $scope.runScheduledTask = function () {
            $scope.running = true;
            LicenseScheduledTasks.run($scope.scheduledTaskID).then(function (log_id) {
                if (log_id != null) {
                    $state.go("internal.licensing.license.scheduledtask.log", {
                        id: $stateParams.id,
                        licenseCategoryID: $stateParams.licenseCategoryID,
                        scheduledTaskID: $stateParams.scheduledTaskID,
                        scheduledTaskLogID: log_id });
                } else {
                    $scope.getCertifications();
                    $scope.running = false;
                }
            });
        };
    }]);